<template>
  <div class="layout-center-wrap">
    <!-- 상단 타이틀 -->
    <section class="page-tit__wrap">
      <h1 class="page-tit__sub">KNVD 소개</h1>
      <p class="page-tit">법률 안내</p>
    </section>
    <!-- 취약점 관련 법률 -->
    <section class="section-pt" aria-labelledby="intro-heading">
      <h2 id="intro-heading" class="section-title">취약점 관련 법률</h2>
      <p class="desc-block">
        한국인터넷진흥원은 아래와 같은 법령을 근거로 하여 보안 취약점 개선 및
        대응을 위한 업무를 수행하고 있습니다.
      </p>
    </section>
    <!-- 보안 취약점 개선 및 대응 관련 -->
    <section class="section-pt" aria-labelledby="intro-heading">
      <h2 id="intro-heading" class="section-title">
        보안 취약점 개선 및 대응 관련
      </h2>
      <p class="section-inter-title">
        정보통신망 이용촉진 및 정보보호 등에 관한 법률
      </p>
      <!-- 제 47조의 4 -->
      <p class="description__law__subtitle">제47조의4(이용자의 정보보호)</p>
      <div class="notice-box">
        <p class="notice-box__text">
          ① 정부는 이용자의 정보보호에 필요한 기준을 정하여 이용자에게 권고하고,
          침해사고의 예방 및 확산 방지를 위하여 취약점 점검, 기술 지원 등 필요한
          조치를 할 수 있다.
        </p>
        <p class="notice-box__text">
          ② 정부는 제1항에 따른 조치에 관한 업무를 한국인터넷진흥원 또는
          대통령령으로 정하는 전문기관에 위탁할 수 있다.
          <span class="color_blue">[신설 2020. 6. 9.]</span>
        </p>
        <p class="notice-box__text">
          ③ 주요정보통신서비스 제공자는 정보통신망에 중대한 침해사고가 발생하여
          자신의 서비스를 이용하는 이용자의 정보시스템 또는 정보통신망 등에
          심각한 장애가 발생할 가능성이 있으면 이용약관으로 정하는 바에 따라 그
          이용자에게 보호조치를 취하도록 요청하고, 이를 이행하지 아니하는
          경우에는 해당 정보통신망으로의 접속을 일시적으로 제한할 수 있다.
          <span class="color_blue">[개정 2020. 6. 9.]</span>
        </p>
        <p class="notice-box__text">
          <strong>
            ④ 「소프트웨어 진흥법」 제2조에 따른 소프트웨어사업자는 보안에 관한
            취약점을 보완하는 프로그램을 제작하였을 때에는 한국인터넷진흥원에
            알려야 하고, 그 소프트웨어 사용자에게는 제작한 날부터 1개월 이내에
            2회 이상 알려야 한다.
            <span class="color_blue">[개정 2009. 4. 22., 2020. 6. 9.]</span>
          </strong>
        </p>
        <p class="notice-box__text">
          ⑤ 「제3항에 따른 보호조치의 요청 등에 관하여 이용약관으로 정하여야
          하는 구체적인 사항은 대통령령으로 정한다.<span class="color_blue">
            [개정 2020. 6. 9.]</span
          >
        </p>
      </div>
      <!-- 제 48조의 2 -->
      <p class="description__law__subtitle">제48조의2(침해사고의 대응 등)</p>
      <div class="notice-box">
        <p class="notice-box__text">
          ① 과학기술정보통신부장관은 침해사고에 적절히 대응하기 위하여 다음 각
          호의 업무를 수행하고, 필요하면 업무의 전부 또는 일부를
          한국인터넷진흥원이 수행하도록 할 수 있다.<span class="color_blue">
            [개정 2009. 4. 22., 2013. 3. 23., 2017. 7. 26.]</span
          >
        </p>
        <p class="notice-box__subtext">
          <strong>1. 침해사고에 관한 정보의 수집ㆍ전파</strong>
        </p>
        <p class="notice-box__subtext">
          <strong>2. 침해사고의 예보ㆍ경보</strong>
        </p>
        <p class="notice-box__subtext">
          <strong>3. 침해사고에 대한 긴급조치</strong>
        </p>
        <p class="notice-box__subtext">
          <strong>4. 그 밖에 대통령령으로 정하는 침해사고 대응조치 </strong>
        </p>
        <p class="notice-box__text">
          ② 다음 각 호의 어느 하나에 해당하는 자는 대통령령으로 정하는 바에 따라
          침해사고의 유형별 통계, 해당 정보통신망의 소통량 통계 및 접속경로별
          이용 통계 등 침해사고 관련 정보를 과학기술정보통신부장관이나
          한국인터넷진흥원에 제공하여야 한다.
          <span class="color_blue"
            >[개정 2009. 4. 22., 2013. 3. 23., 2017. 7. 26.]</span
          >
        </p>
        <p class="notice-box__subtext">1. 주요정보통신서비스 제공자</p>
        <p class="notice-box__subtext">2. 집적정보통신시설 사업자</p>
        <p class="notice-box__subtext">
          3. 그 밖에 정보통신망을 운영하는 자로서 대통령령으로 정하는 자
        </p>

        <p class="notice-box__text">
          ③ 한국인터넷진흥원은 제2항에 따른 정보를 분석하여
          과학기술정보통신부장관에게 보고하여야 한다.<span class="color_blue">
            [개정 2009. 4. 22., 2013. 3. 23., 2017. 7. 26.]</span
          >
        </p>
        <p class="notice-box__text">
          ④ 과학기술정보통신부장관은 제2항에 따라 정보를 제공하여야 하는
          사업자가 정당한 사유 없이 정보의 제공을 거부하거나 거짓 정보를
          제공하면 상당한 기간을 정하여 그 사업자에게 시정을 명할 수 있다.<span
            class="color_blue"
          >
            [개정 2013. 3. 23., 2017. 7. 26.]</span
          >
        </p>
        <p class="notice-box__text">
          ⑤ 과학기술정보통신부장관이나 한국인터넷진흥원은 제2항에 따라 제공받은
          정보를 침해사고의 대응을 위하여 필요한 범위에서만 정당하게 사용하여야
          한다.
          <span class="color_blue"
            >[개정 2009. 4. 22., 2013. 3. 23., 2017. 7. 26.]</span
          >
        </p>
        <p class="notice-box__text">
          ⑥ 과학기술정보통신부장관이나 한국인터넷진흥원은 침해사고의 대응을
          위하여 필요하면 제2항 각 호의 어느 하나에 해당하는 자에게 인력지원을
          요청할 수 있다.
          <span class="color_blue"
            >[개정 2009. 4. 22., 2013. 3. 23., 2017. 7. 26.]</span
          >
        </p>
      </div>
      <!-- 제 76조 -->
      <p class="description__law__subtitle">제76조(과태료)</p>
      <div class="notice-box">
        <p class="notice-box__text">
          ① 다음 각 호의 어느 하나에 해당하는 자와 제7호부터 제11호까지의 경우에
          해당하는 행위를 하도록 한 자에게는 3천만원 이하의 과태료를 부과한다.
          <span class="color_blue">
            [개정 2011. 3. 29., 2012. 2. 17., 2013. 3. 23., 2014. 5. 28., 2015.
            6. 22., 2015. 12. 1., 2016. 3. 22., 2017. 7. 26., 2018. 9. 18.,
            2020. 2. 4., 2021. 6. 8.]</span
          >
        </p>
        <p class="notice-box__text">[...생략...]</p>
        <p class="notice-box__text">
          ③ 다음 각 호의 어느 하나에 해당하는 자에게는 1천만원 이하의 과태료를
          부과한다.
          <span class="color_blue"
            >[개정 2009. 4. 22., 2011. 4. 5., 2012. 2. 17., 2014. 5. 28., 2015.
            6. 22., 2015. 12. 1., 2016. 3. 22., 2017. 7. 26., 2018. 6. 12.,
            2020. 2. 4., 2020. 6. 9.]</span
          >
        </p>
        <p class="notice-box__subtext">
          1. 삭제<span class="color_blue"> [2015. 6. 22.]</span>
        </p>
        <p class="notice-box__subtext">
          2. 삭제<span class="color_blue"> [2015. 6. 22.]</span>
        </p>
        <p class="notice-box__subtext">
          2의2. 제23조의3제1항을 위반하여 본인확인기관의 지정을 받지 아니하고
          본인확인업무를 한 자
        </p>
        <p class="notice-box__subtext">
          2의3. 제23조의3제2항에 따른 본인확인업무의 휴지 또는 같은 조 제3항에
          따른 본인확인업무의 폐지 사실을 이용자에게 통보하지 아니하거나
          방송통신위원회에 신고하지 아니한 자
        </p>
        <p class="notice-box__subtext">
          2의4. 제23조의4제1항에 따른 본인확인업무의 정지 및 지정취소 처분에도
          불구하고 본인확인업무를 계속한 자
        </p>
        <p class="notice-box__subtext">
          <span class="color_blue">2의5. 삭제 [2020. 2. 4.]</span>
        </p>

        <p class="notice-box__subtext">
          3. 제42조의3제1항을 위반하여 청소년 보호 책임자를 지정하지 아니한 자
        </p>
        <p class="notice-box__subtext">
          4. 제43조를 위반하여 정보를 보관하지 아니한 자
        </p>
        <p class="notice-box__subtext">
          5. 삭제 <span class="color_blue">[2018. 6. 12.]</span>
        </p>
        <p class="notice-box__subtext">
          6. 삭제 <span class="color_blue">[2015. 12. 1.]</span>
        </p>
        <p class="notice-box__subtext">
          7. 제47조제9항을 위반하여 인증받은 내용을 거짓으로 홍보한 자
        </p>
        <p class="notice-box__subtext">
          8. 삭제<span class="color_blue"> [2012. 2. 17.]</span>
        </p>
        <p class="notice-box__subtext">
          9. 삭제<span class="color_blue"> [2012. 2. 17.]</span>
        </p>
        <p class="notice-box__subtext">
          <strong>
            10. 제47조의4제4항을 위반하여 소프트웨어 사용자에게 알리지 아니한 자
          </strong>
        </p>
        <p class="notice-box__subtext">
          11. 제48조의2제4항에 따른 시정명령을 이행하지 아니한 자
        </p>
        <p class="notice-box__subtext">
          11의2. 제48조의3제1항을 위반하여 침해사고의 신고를 하지 아니한 자
        </p>
        <p class="notice-box__subtext">
          12. 제48조의4제4항에 따른 사업장 출입 및 조사를 방해하거나 거부 또는
          기피한 자
        </p>
        <p class="notice-box__subtext">[...생략...]</p>
      </div>
      <p class="section-inter-title">
        정보통신망 이용촉진 및 정보보호 등에 관한 법률 시행령
      </p>
      <!-- 제 56조 -->
      <p class="description__law__subtitle">제56조(침해사고 대응조치)</p>
      <div class="notice-box">
        <p class="notice-box__text">
          법 제48조의2제1항제4호에서 “그 밖에 대통령령으로 정한 침해사고
          대응조치”란 다음 각 호의 조치를 말한다.<span class="color_blue">
            [개정 2009. 1. 28., 2020. 12. 8.]</span
          >
        </p>
        <p class="notice-box__text">
          1. 주요정보통신서비스 제공자 및 법 제46조제1항에 따른 타인의
          정보통신서비스 제공을 위하여 집적된 정보통신시설을 운영ㆍ관리하는
          사업자에 대한 접속경로(침해사고 확산에 이용되고 있거나 이용될 가능성이
          있는 접속경로만 해당한다)의 차단 요청
        </p>
        <p class="notice-box__text">
          <strong>
            2. 「소프트웨어 진흥법」 제2조제4호에 따른 소프트웨어사업자 중
            침해사고와 관련이 있는 소프트웨어를 제작 또는 배포한 자에 대한 해당
            소프트웨어의 보안상 취약점을 수정ㆍ보완한 프로그램(이하
            “보안취약점보완프로그램”이라 한다)의 제작ㆍ배포 요청 및
            정보통신서비스 제공자에 대한 보안취약점보완프로그램의 정보통신망
            게재 요청</strong
          >
        </p>
        <p class="notice-box__text">
          3. 언론기관 및 정보통신서비스 제공자에 대한 법 제48조의2제1항제2호에
          따른 침해사고 예보ㆍ경보의 전파
        </p>
        <p class="notice-box__text">
          4. 국가 정보통신망 안전에 필요한 경우 관계 기관의 장에 대한 침해사고
          관련정보의 제공
        </p>
      </div>
    </section>
    <section class="section-pt" aria-labelledby="intro-heading">
      <h2 id="intro-heading" class="section-title">
        보안 취약점 신고포상제 운영
      </h2>
      <p class="desc-block">
        또한, 아래와 같은 법령을 근거로 하여 보안 취약점 신고포상제를 운영하고
        있습니다.
      </p>
      <p class="section-inter-title">
        정보통신망 이용촉진 및 정보보호 등에 관한 법률
      </p>
      <!-- 제 47조의 6 -->
      <p class="description__law__subtitle">
        제47조의6(정보보호 취약점 신고자에 대한 포상)
      </p>
      <div class="notice-box">
        <p class="notice-box__text">
          ① 정부는 침해사고의 예방 및 피해 확산 방지를 위하여 정보통신서비스,
          정보통신망연결기기등 또는 소프트웨어의 보안에 관한 취약점(이하
          "정보보호 취약점"이라 한다)을 신고한 자에게 예산의 범위에서 포상금을
          지급할 수 있다.
        </p>
        <p class="notice-box__text">
          ② 제1항에 따른 포상금의 지급 대상·기준 및 절차 등은<strong>
            대통령령</strong
          >으로 정한다.
        </p>
        <p class="notice-box__text">
          ③ 정부는 제1항에 따른 포상금 지급에 관한 업무를 한국인터넷진흥원에
          위탁할 수 있다.
        </p>
        <p class="notice-box__text color_blue">[본조신설 2022. 6. 10.]</p>
      </div>
      <p class="section-inter-title">
        정보통신망 이용촉진 및 정보보호 등에 관한 법률 시행령
      </p>
      <!-- 제 47조의 6 -->
      <p class="description__law__subtitle">
        제55조의6(정보보호 취약점 신고자에 대한 포상)
      </p>
      <div class="law-notice-box">
        <p class="notice-box__text">
          ① 법 제47조의6제1항에 따른 포상금의 지급 대상ㆍ기준 및 절차는 별표
          4의2와 같다.
        </p>
        <p class="notice-box__text">
          ② 과학기술정보통신부장관은 법 제47조의6제3항에 따라 포상금 지급에 관한
          업무를 인터넷진흥원에 위탁하는 경우에는 위탁업무의 내용을 고시해야
          한다.
        </p>
        <p class="notice-box__text color_blue">[본조신설 2022. 12. 9.]</p>
      </div>
    </section>
  </div>
</template>

